import { useLogin, useNotify } from 'react-admin';
import { useState } from 'react';
import { Button, TextField, Card, CardContent, CardActions } from '@mui/material';

const CustomLoginPage = () => {
  const login = useLogin();
  const notify = useNotify();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    login({ email, password }).catch(() => notify('Login fehlgeschlagen', { type: 'error' }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <CardContent>
          <TextField fullWidth label="E-Mail" value={email} onChange={(e) => setEmail(e.target.value)} />
          <TextField fullWidth label="Passwort" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </CardContent>
        <CardActions>
          <Button type="submit" color="primary" variant="contained">
            Einloggen
          </Button>
        </CardActions>
      </Card>
    </form>
  );
};

export default CustomLoginPage;